import { markRaw as p } from "vue";
import { A as o } from "../lib/api.DveR7HGv.js";
function m(i) {
  i.store.$api = p(new o());
}
export {
  m as p
};
